import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-user',
	templateUrl: './icon-user.component.svg',
})
export class IconUserComponent {}
